module.exports = __webpack_public_path__ + "static/media/linkedin-socials-social-media-icon-svgrepo-com.85279c26.svg";